import { useState } from "react";
import { Suggestion } from "./ResultTypes";
import { voteOnSuggestionPost } from "./services";

export function SuggestionBox({
  initalSuggestions,
  landlord,
}: {
  initalSuggestions: Suggestion[];
  landlord?: boolean;
}) {
  const [votedDict, setVotedDict] = useState({} as { [key: string]: number });
  const [suggestions, setSuggestions] = useState(initalSuggestions);

  function voteOnSuggestion(id: string, vote: -1 | 1) {
    if (votedDict[id] === vote) {
      return;
    }

    const suggestion = suggestions.find((s: any) => s.id === id);

    suggestion!.votesUp += vote;

    setSuggestions([...suggestions]);

    votedDict[id] = vote;
    setVotedDict(votedDict);

    voteOnSuggestionPost(id, vote);
  }

  return (
    <div className="suggestion-container">
      <div className="owned_by">
        {landlord ? (
          <>
            users have suggested the actual <span>owner</span> is:
          </>
        ) : (
          <>
            users have suggested the <span>property manager</span> is one of the
            following:
          </>
        )}
      </div>
      {suggestions.map((edit: Suggestion, i: number) => (
        <div className="suggestion" key={edit.id}>
          <p className="suggested-owner-name">{edit.data}</p>
          <div className="vote-box">
            <button
              className="vote-button green vote-up"
              onClick={() => voteOnSuggestion(edit.id, 1)}
            ></button>
            <div className="vote-count">{edit.votesUp - edit.votesDown}</div>
            <button
              className="vote-button red vote-down"
              onClick={() => voteOnSuggestion(edit.id, -1)}
            ></button>
          </div>
        </div>
      ))}
    </div>
  );
}
